import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

const About = () => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="absolute top-10 right-10 w-24 h-24 pattern-dots opacity-40 hidden md:block" />

      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src="https://images.unsplash.com/photo-1519638399535-1b036603ac77?w=600"
                  alt="Children learning"
                  className="w-full h-56 object-cover rounded-3xl shadow-lg"
                />
                <img
                  src="https://images.pexels.com/photos/8535171/pexels-photo-8535171.jpeg?w=800"
                  alt="Yoga"
                  className="w-full h-40 object-cover rounded-3xl shadow-lg"
                />
              </div>
              <div className="space-y-4 pt-8">
                <img
                  src="https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?w=600"
                  alt="Art class"
                  className="w-full h-40 object-cover rounded-3xl shadow-lg"
                />
                <img
                  src="https://images.pexels.com/photos/5211460/pexels-photo-5211460.jpeg?w=800"
                  alt="Classroom"
                  className="w-full h-56 object-cover rounded-3xl shadow-lg"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-orange-500 to-amber-500 text-white rounded-2xl p-5 shadow-2xl hidden md:block">
              <p className="font-display font-bold text-3xl">2027</p>
              <p className="text-xs uppercase tracking-wider">Grand Launch</p>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-100 border border-amber-200 mb-4">
              <Sparkles className="w-4 h-4 text-amber-700" />
              <span className="text-xs font-semibold text-amber-800 tracking-wide uppercase">About Us</span>
            </div>

            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-5 leading-tight">
              Where <span className="text-orange-600">Sanskaar</span> meets
              <br />
              <span className="text-amber-600">Smart Learning</span>
            </h2>

            <p className="text-stone-600 leading-relaxed mb-4">
              <span className="font-semibold text-stone-800">Aadi Gayanam Play School</span>, an upcoming initiative by the <span className="font-semibold text-orange-700">Aarohi Welfare Foundation, Jaipur</span>, is a pioneering early childhood institution set to launch on <span className="font-semibold text-orange-700">1st January 2027</span>. Our mission is to seamlessly weave the timeless wisdom of Sanatan Dharma with contemporary, research-backed learning methodologies.
            </p>
            <p className="text-stone-600 leading-relaxed mb-6">
              From daily Sanskrit shlokas and yoga to phonics, STEM basics and creative arts – every child at Aadi Gayanam grows into a confident, curious and culturally-rooted individual.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                "Sanatan Values",
                "Modern Pedagogy",
                "Sanskrit Shlokas",
                "Yoga & Wellness"
              ].map((f, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <div className="w-2 h-2 rounded-full bg-orange-600" />
                  </div>
                  <span className="text-sm font-medium text-stone-700">{f}</span>
                </div>
              ))}
            </div>

            <Link to="/about">
              <Button className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white rounded-full px-8 h-12 shadow-lg btn-shine">
                Discover Our Story <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
